<template>
  <v-container class="page-container p-3">
    <ExpenseContainer />
  </v-container>
</template>

<script>
import ExpenseContainer from "@/components/Container/ExpenseContainer.vue"
export default {
  components: { ExpenseContainer },
}
</script>
